module.exports = __webpack_public_path__ + "media/images/WFC_Portrait_White_w_0-c74d1b805bedff9b08befca477691e86.svg";